import React from 'react'

import { useAuth } from '../../AuthContext'


function TikTokAuth() 
{


    const myContext = useAuth()

const CLIENT_KEY     = "awo3nm5j9urpuk42";
const REDIRECT_URI  = "https://schedpilot.com/wp-json/api/v1/callback-tiktok";
const SCOPE         = "user.info.basic,video.upload,video.publish,video.list";


function generateRandomString(length = 43) {
  const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  const array = new Uint32Array(length);
  window.crypto.getRandomValues(array);

  for (let i = 0; i < length; i++) {
    result += charset[array[i] % charset.length];
  }

  return result;
} 


const getAuthURL = () =>
{ 
    
  const authUrl = `https://www.tiktok.com/v2/auth/authorize/?` +
    `client_key=${CLIENT_KEY}&` +
    `redirect_uri=${encodeURIComponent(REDIRECT_URI)}&` +
    `response_type=code&` +
    `scope=${(SCOPE)}&state=` +  generateRandomString(30)

  return authUrl;
};

 

const handleConnectTikTok = async () => 
{

        const xurl = getAuthURL();
        const width = 600, height = 800;
        const left = (window.innerWidth - width) / 2;
        const top = (window.innerHeight - height) / 2;
    
        let authWindow = window.open(
            xurl,
            'TikTok Auth',
            `toolbar=yes, location=yes, directories=yes, status=yes, menubar=yes, scrollbars=yes, resizable=yes, copyhistory=no, width=${width}, height=${height}, top=${top}, left=${left}`
        );
        
 

         const jwtToken2 = myContext.jwtToken;

         console.log(jwtToken2)
        
                window.addEventListener("message", async event => {
 


            if (event.data.type == "tiktok-authenticated") 
            {
 
 
                const access_token  = event.data.access_token; 
                const open_id = event.data.open_id;   
                const refresh_token = event.data.refresh_token;   

                const expires_in = event.data.expires_in;   
                const refresh_expires_in = event.data.refresh_expires_in;   

       
                authWindow.close();
                
                const item = await fetch("https://api.schedpilot.com/wp-json/api/v2/token-exchange-tiktok/?refresh_token="+ refresh_token
            +"&access_token=" + access_token + "&open_id=" + open_id +  "&refresh_expires_in=" + refresh_expires_in + "&expires_in=" + expires_in +
             "&jwtToken=" + jwtToken2 + "&rand=" + generateRandomString(40));

                                 myContext.getAccountsData();

 
     
            }


            
        });
    
    

    }
 




  return (
    <>
      <button className='btn btn-primary' onClick={handleConnectTikTok}> 
      <p className='p-0 m-0'>Connect TikTok</p></button>
    </>
  )
}

export default TikTokAuth
